import { useMutation } from '@tanstack/react-query';
import { POST, POST_LINE_MESSAGE_TEMPLATE_DELETE } from '../../../services';
import { openAlert } from '../../../components/alert/useAlert';

export const useDeleteLineMessageTemplate = ({ onSuccessCallBack } = {}) =>
  useMutation({
    mutationFn: async ({ templateId }) => {
      const response = await POST(POST_LINE_MESSAGE_TEMPLATE_DELETE(), { templateId });
      if (response?.success === false) throw new Error(response.message);
      return response?.result;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'ลบ template สำเร็จ' });
      onSuccessCallBack?.();
    },
  });
